import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeatures0getGetFeaturesResponseSchema = jsonObject
export type tcpfeatures0getGetFeaturesResponse = z.infer<typeof tcpfeatures0getGetFeaturesResponseSchema>
